// extracted by mini-css-extract-plugin
module.exports = {"whenToGo":"styles_whenToGo__Izgmj","section_description":"styles_section_description__PfMsI"};